import { render, staticRenderFns } from "./DownloadsCard.vue?vue&type=template&id=5327faf6&scoped=true&"
import script from "./DownloadsCard.vue?vue&type=script&lang=js&"
export * from "./DownloadsCard.vue?vue&type=script&lang=js&"
import style0 from "./DownloadsCard.vue?vue&type=style&index=0&id=5327faf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5327faf6",
  null
  
)

export default component.exports